import overlay from './loader';
import updateMiniCart from "./update-mini-cart";
import updateCartIconQuantity from "./update-cart-icon";
import debounce from '../utils/debouncer';
import updateDatalayer from "./gtm";
import $ from "jquery";

function updateItem(cartId, rowId) {
    overlay(true);
    let cartUrl = window.config.urls.cartProduct.replace(':cart:', cartId)
    let apiUrl = cartUrl.replace(':row:', rowId);
    let data = $('#miniCartBody div.is-mini-cart-item form').serialize();

    window.axios.patch(apiUrl, data)
        .then(() => {
            if (window.location.href.startsWith(window.config.urls.cart)) {
                // if currently on cart overview, refresh page to sync TODO improve cart/minicart syncing
                window.location.reload();
            }

            updateMiniCart();
        }).finally(() => overlay(false));
}

$(document).ready(function () {
    updateCartIconQuantity();

    $(document).on('click', '.delete-mini-cart-item', function (e) {
        let element = $(this);
        let cartId = element.data('cart-id');
        let rowId = element.data('row-id');
        const product_name = element.data('product-name');
        const product_number = element.data('product-number');
        const price = element.data('price');
        let cartUrl = window.config.urls.flyoutCart.cartProduct.replace(':cart:', cartId)
        let apiUrl = cartUrl.replace(':row:', rowId);
        window.axios.delete(apiUrl).then(({data}) => {
            if(data.success) {
                updateDatalayer(
                    'remove_from_cart',
                    product_number,
                    product_name,
                    1,
                    price,
                    null
                );

                if (! window.location.href.startsWith(window.config.urls.cart)) { // if currently on cart overview, refresh page to sync instead TODO improve cart/minicart syncing)
                    updateMiniCart().then(updateCartIconQuantity);
                    updateDatalayer('remove_from_cart', product_number, product_name, 1, price, null);
                    overlay(false);
                } else {
                    window.location.reload();
                }
            }
        });
    });

    $(document).on('change', 'input.mini-cart', function (e) {
        let val = parseFloat($(this).val());
        $('#miniCartBody div.is-mini-cart-item input.quantity').val(val);
        let cartId = $('#miniCartBody').data('cart-id');
        let rowId = $(this).closest('.is-mini-cart-item').find('input.rowId').val();

        let item = $(this).closest('.is-mini-cart-item')

        debounce(item, () => {
            updateItem(cartId, rowId);
        }, 700);

        e.stopPropagation();
    });

    document.getElementById('offcanvasMiniCart').addEventListener('show.bs.offcanvas', function () {
        updateMiniCart();
    });
});
